import { Component, Input, OnInit } from "@angular/core";

export interface Info {
  descriptor_name: string;
  value: string;
}

export interface InputTemplate {
  main_icon: string | boolean;
  main_title: string | boolean;
  title: string | boolean;
  color: string;
  image: string | boolean;
  info_list: Info[];
}

@Component({
  selector: "app-template-a",
  templateUrl: "./template-a.component.html",
  styleUrls: ["./template-a.component.css"],
})
export class TemplateAComponent implements OnInit {
  constructor() {}

  limit_1!: number;
  limit_2!: number;

  @Input() inputTemplate!: InputTemplate;
  has_values: boolean = false;

  ngOnInit(): void {
    const _length = this.inputTemplate.info_list.length;
    this.has_values = _length > 0 ? true : false;

    if (_length % 2 == 0) {
      this.limit_2 = _length;
      this.limit_1 = _length / 2;
    } else {
      this.limit_2 = 1 + _length;
      this.limit_1 = 1 + _length / 2;
    }
  }
}
